import type { HTMLAttributes, ReactNode } from 'react';
import './Badge.css';

export type BadgeTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'accent';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  children: ReactNode;
}

export function Badge({ tone = 'neutral', children, className = '', ...rest }: BadgeProps) {
  return (
    <span className={`badge badge-${tone} ${className}`.trim()} {...rest}>
      {children}
    </span>
  );
}
